import * as types from 'actions/types';
import { createReducer, successType } from 'lib/callAPI';

const skillsReducer = (state = null, action) => {
  switch (action.type) {
    case successType(types.GET_SKILLS):
      return [...action.response];
    default:
      return state;
  }
};

export default createReducer(types.GET_SKILLS, skillsReducer);
